import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../../contexts/AuthContext';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const fmt = (d) => d ? String(d).slice(0, 10) : '';

const th = { padding: '0.5rem 0.75rem', background: 'linear-gradient(135deg,#D84315,#F57C00)', color: '#fff', fontWeight: 600, fontSize: '0.8rem', textAlign: 'left', whiteSpace: 'nowrap' };
const td = { padding: '0.45rem 0.75rem', fontSize: '0.875rem', borderBottom: '1px solid #e0e0e0', color: '#2c3e50' };
const inp = { padding: '0.4rem 0.6rem', border: '1px solid #ccc', borderRadius: 5, fontSize: '0.875rem' };
const btn = (variant = 'primary') => ({
  padding: '0.4rem 0.9rem', border: 'none', borderRadius: 5, fontWeight: 600, fontSize: '0.8rem', cursor: 'pointer',
  background: variant === 'primary' ? 'linear-gradient(135deg,#D84315,#F57C00)' : variant === 'secondary' ? '#e0e0e0' : '#17a2b8',
  color: variant === 'secondary' ? '#333' : '#fff',
});

export default function Invoices() {
  const { user } = useContext(AuthContext);
  const headers = { Authorization: `Bearer ${user?.token}` };
  const navigate = useNavigate();

  const [form, setForm] = useState({ invoice_no: '', invoice_date: '', order_no: '', customer_id: '' });
  const [customers, setCustomers] = useState([]);
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    axios.get(`${API_URL}/commonLOVs/lhcustomers`, { headers }).then(r => setCustomers(r.data || [])).catch(() => {});
    fetchInvoices();
  }, []);

  const fetchInvoices = async (f = form) => {
    try {
      const params = new URLSearchParams(f).toString();
      const res = await axios.get(`${API_URL}/invoices/invoices?${params}`, { headers });
      setInvoices(res.data || []);
    } catch { setInvoices([]); }
  };

  const reset = () => {
    const empty = { invoice_no: '', invoice_date: '', order_no: '', customer_id: '' };
    setForm(empty);
    setInvoices([]);
  };

  const download = async (id) => {
    try {
      const res = await axios.get(`${API_URL}/invoices/print-invoice/${id}`, { headers, responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
    } catch { alert('Failed to download invoice.'); }
  };

  return (
    <div style={{ padding: '1.25rem' }}>
      <button style={{ ...btn('secondary'), marginBottom: '1rem' }} onClick={() => navigate(-1)}>← Back</button>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h2 style={{ margin: 0, fontSize: '1.2rem', color: '#2c3e50' }}>Invoices</h2>
        <button style={btn()} onClick={() => navigate('/bank/create-invoice')}>+ Create Invoice</button>
      </div>

      {/* Search */}
      <div style={{ background: '#fff', border: '1px solid #e0e0e0', borderRadius: 8, padding: '1rem', marginBottom: '1rem', display: 'flex', flexWrap: 'wrap', gap: '0.6rem', alignItems: 'flex-end' }}>
        <input style={inp} placeholder="Invoice No" value={form.invoice_no} onChange={e => setForm(p => ({ ...p, invoice_no: e.target.value }))} />
        <input style={inp} type="date" value={form.invoice_date} onChange={e => setForm(p => ({ ...p, invoice_date: e.target.value }))} />
        <input style={inp} placeholder="Order No" value={form.order_no} onChange={e => setForm(p => ({ ...p, order_no: e.target.value }))} />
        <select style={inp} value={form.customer_id} onChange={e => setForm(p => ({ ...p, customer_id: e.target.value }))}>
          <option value="">Select Customer</option>
          {customers.map(c => <option key={c.id} value={c.id}>{c.customer_name}</option>)}
        </select>
        <button style={btn()} onClick={() => fetchInvoices(form)}>Search</button>
        <button style={btn('secondary')} onClick={reset}>Reset</button>
      </div>

      {/* Table */}
      <div style={{ background: '#fff', border: '1px solid #e0e0e0', borderRadius: 8, overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={th}>Invoice No</th>
              <th style={th}>Invoice Date</th>
              <th style={th}>Customer</th>
              <th style={th}>Amount</th>
              <th style={th}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {invoices.length === 0 ? (
              <tr><td colSpan={5} style={{ ...td, textAlign: 'center', color: '#999', padding: '1.5rem' }}>No invoices found.</td></tr>
            ) : invoices.map(inv => (
              <tr key={inv.id}>
                <td style={td}>{inv.invoice_no}</td>
                <td style={td}>{fmt(inv.invoice_date)}</td>
                <td style={td}>{inv.customer_name}</td>
                <td style={td}>{parseFloat(inv.invoice_amount || 0).toFixed(2)}</td>
                <td style={td}>
                  <button style={btn('info')} onClick={() => download(inv.id)}>Print</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
